<main class="bg-gray-50 min-h-screen" style="font-family: 'Inter', 'Mona Sans', sans-serif;">
    <div class="min-h-screen flex">
        <section class="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-[#1b6dba] via-[#1b6dba] to-purple-800 relative overflow-hidden">
            <div class="absolute inset-0 opacity-10">
                <svg class="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
                    <defs>
                        <pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse">
                            <path d="M 10 0 L 0 0 0 10" fill="none" stroke="white" stroke-width="0.5"></path>
                        </pattern>
                    </defs>
                    <rect width="100" height="100" fill="url(#grid)"></rect>
                </svg>
            </div>

            <div class="absolute top-20 left-20 w-64 h-64"></div>
            <!-- <div class="absolute bottom-20 right-20 w-96 h-96 bg-purple-500/20 rounded-full blur-3xl"></div> -->

            <div class="relative z-10 flex flex-col justify-center px-12 xl:px-20"> 
                <!-- <div class="flex items-center mb-12">
                    <div class="w-12 h-12 bg-white rounded-xl flex items-center justify-center shadow-lg">
                        <i class="fas fa-file-signature text-indigo-600 text-xl"></i>
                    </div>
                    <span class="ml-3 text-2xl font-bold text-white">SignPaperless</span>
                </div> -->


                 <!-- <img src="assets/images/logo/img1.png" alt="icon" class=""> -->

                 <img src="assets/images/logo/Sign_paperless_dark.svg" alt="icon" class="mb-3 w-75 img-fluid" style="margin-left: -11px !important;">


                <h1 class="text-4xl xl:text-5xl font-bold text-white leading-tight mb-6">
                    Secure, Seamless<br>
                    <span class="text-indigo-200">Digital Signatures</span>
                </h1>

                <p class="text-lg text-indigo-100 mb-10 max-w-md">
                    Sign documents from anywhere. Our enterprise-grade platform makes electronic signatures simple, secure, and tempered proof.
                </p>

                <div class="space-y-4">
                    <div class="flex items-center text-white">
                        <div class="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center mr-4">
                            <i class="fas fa-shield-alt text-indigo-200"></i>
                        </div>
                        <span class="text-indigo-100">Track it live. Control it fully</span>
                    </div>
                    <div class="flex items-center text-white">
                        <div class="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center mr-4">
                            <i class="fas fa-bolt text-indigo-200"></i>
                        </div>
                        <span class="text-indigo-100">Fast signatures. Faster decisions</span>
                    </div>
                    <div class="flex items-center text-white">
                        <div class="w-10 h-10 rounded-lg bg-white/10 flex items-center justify-center mr-4">
                            <i class="fas fa-globe text-indigo-200"></i>
                        </div>
                        <span class="text-indigo-100">Less paper, less cost, more efficiency</span>
                    </div>
                </div>

                <!-- <div class="mt-12 pt-8 border-t border-white/10">
                    <p class="text-sm text-indigo-200 mb-4">Trusted by leading companies</p>
                    <div class="flex items-center gap-8 opacity-70">
                        <span class="text-white font-semibold">Acme Corp</span>
                        <span class="text-white font-semibold">TechFlow</span>
                        <span class="text-white font-semibold">GlobalSoft</span>
                    </div>
                </div> -->
            </div>
        </section>

        <section class="w-full lg:w-1/2 flex items-center justify-center p-8">
            <div class="w-full max-w-md">
                <div class="lg:hidden flex items-center justify-center mb-8">
                    <div class="w-12 h-12 bg-indigo-600 rounded-xl flex items-center justify-center shadow-lg">
                        <i class="fas fa-file-signature text-white text-xl"></i>
                    </div>
                    <span class="ml-3 text-2xl font-bold text-gray-900">SignPaperless</span>
                </div>

                <div class="text-center mb-8">
                    <h2 class="text-3xl font-bold text-gray-900 mb-2">Welcome</h2>
                    <p class="text-gray-500">Sign in to your account to continue</p>
                </div>

                <!-- <div class="grid grid-cols-2 gap-3 mb-6">
                    <button type="button" class="flex items-center justify-center px-4 py-3 border border-gray-200 rounded-xl hover:bg-gray-50 transition-colors">
                        <i class="fab fa-google text-lg mr-2 text-red-500"></i>
                        <span class="text-sm font-medium text-gray-700">Google</span>
                    </button>
                    <button type="button" class="flex items-center justify-center px-4 py-3 border border-gray-200 rounded-xl hover:bg-gray-50 transition-colors">
                        <i class="fab fa-microsoft text-xl mr-2 text-blue-500"></i>
                        <span class="text-sm font-medium text-gray-700">Microsoft</span>
                    </button>
                </div> -->

                <!-- <div class="relative mb-6">
                    <div class="absolute inset-0 flex items-center">
                        <div class="w-full border-t border-gray-200"></div>
                    </div>
                    <div class="relative flex justify-center text-sm">
                        <span class="px-4 bg-gray-50 text-gray-500">or continue with email</span>
                    </div>
                </div> -->

                <form autocomplete="off" [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="space-y-5">
                    <div>
                        <label for="loginEmail" class="block text-sm font-medium text-gray-700 mb-2">{{"COMMON.EMAIL_ADDRESS" | translate}}</label>
                        <div class="relative">
                            <span class="absolute inset-y-0 left-0 pl-4 flex items-center text-gray-400">
                                <i class="fas fa-envelope"></i>
                            </span>
                            <input id="loginEmail" type="email" formControlName="email" placeholder="name@company.com"
                                class="w-full pl-11 pr-4 py-3 border border-gray-200 rounded-xl bg-white text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent">
                        </div>
                        <div class="min-h-[10px] mt-1">
                        @if(field['email'].invalid && (field['email'].touched || field['email'].dirty || isFieldValid())){
                        <div class="required-txt-error text-danger mt-1">
                            @if(field['email'].errors?.['required']){
                            <div>{{"ERROR.EMAIL_REQUIRED" | translate}}</div>
                            }
                            @if(field['email'].errors?.['email']){
                            <div>{{"ERROR.EMAIL_VALID" | translate}}</div>
                            }
                        </div>
                        }
                        </div>
                    </div>

                    <div>
                        <label for="loginPassword" class="block text-sm font-medium text-gray-700 mb-2">{{"COMMON.PASSWORD" | translate}}</label>
                        <div class="relative">
                            <span class="absolute inset-y-0 left-0 pl-4 flex items-center text-gray-400">
                                <i class="fas fa-lock"></i>
                            </span>
                            <input id="loginPassword" [type]="showPassword ? 'text' : 'password'" formControlName="password" placeholder="••••••••"
                                class="w-full pl-11 pr-12 py-3 border border-gray-200 rounded-xl bg-white text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent">
                            <button type="button" (click)="toggleShowPassword()" class="absolute inset-y-0 right-0 pr-4 flex items-center text-gray-400 hover:text-gray-600">
                                <i class="fas fa-eye" *ngIf="!showPassword"></i>
                                <i class="fas fa-eye-slash" *ngIf="showPassword"></i>
                            </button>
                        </div>
                        <div class="min-h-[10px] mt-1">
                        @if((field['password'].invalid && (field['password'].dirty || field['password'].touched || isFieldValid()))){
                        <div class="required-txt-error text-danger mt-1">
                            @if(field['password'].errors?.['required']){
                            <div>{{"ERROR.PASSWORD_REQUIRED" | translate}}</div>
                            }
                        </div>
                        }
                        </div>
                    </div>

                    <div class="flex items-center justify-between">
                        <label class="flex items-center">
                            <input type="checkbox" class="w-4 h-4 rounded border-gray-300 text-indigo-600 focus:ring-primary-500">
                            <span class="ml-2 text-sm text-gray-600">{{"AUTH.REMEMBER_ME" | translate}}</span>
                        </label>
                        <!-- <button type="button" class="text-sm font-medium text-indigo-600 hover:text-indigo-500">{{"AUTH.FORGOT_PASSWORD" | translate}}</button> -->
                    </div>

                    <button type="submit" class="w-full flex items-center justify-center px-4 py-3 rounded-xl text-white font-semibold bg-[#1800add1] transition-colors shadow-md">
                        {{"AUTH.SIGN_IN" | translate}}
                        <i class="fas fa-arrow-right ml-2"></i>
                    </button>
                </form>

                <!-- <p class="mt-8 text-center text-sm text-gray-500">
                    {{"AUTH.DO_HAVE_AN_ACCOUNT" | translate}}
                    <button type="button" class="font-medium text-indigo-600 hover:text-indigo-500">{{ "AUTH.SIGNUP_FREE" | translate }}</button>
                </p> -->
            </div>
        </section>
    </div>
</main>